module.exports = __webpack_public_path__ + "media/images/antara1_star-46f78ab16bfcbf164a4e381ba34e139e.png";